import { render, staticRenderFns } from "./chat_count_list.vue?vue&type=template&id=158bb1a3"
import script from "./chat_count_list.vue?vue&type=script&lang=ts"
export * from "./chat_count_list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports